import { useQuery } from 'react-query';
import { axios } from '@/lib/axios';
import { useNotificationStore } from '@/stores/notifications';

export const getTablesList = ({
  keyword = '',
  columnNameKeyword = '',
  tableNameKeyword = '',
  integrationId = '',
  pageNumber = 1,
}) => {
  return axios.get(
    `/api/v1/integration/data-dictionaries/tables?keyword=${keyword}&columnNameKeyword=${columnNameKeyword}&tableNameKeyword=${tableNameKeyword}&integrationId=${integrationId}&pageSize=100&pageNumber=${pageNumber}`
  );
};

export const useGetTablesList = ({
  keyword = '',
  columnNameKeyword,
  tableNameKeyword,
  integrationId,
  pageNumber,
  config,
}) => {
  const { addNotification } = useNotificationStore();

  const queryKey = [
    'allTables',
    keyword,
    columnNameKeyword,
    tableNameKeyword,
    integrationId,
    pageNumber,
  ];
  return useQuery(
    queryKey,
    () =>
      getTablesList({
        keyword,
        columnNameKeyword,
        tableNameKeyword,
        integrationId,
        pageNumber,
      }),
    {
      ...config,
      onError: (error) => {
        addNotification({ type: 'error', title: error.message });
      },
    }
  );
};
